import { getSymplouGenerativeModel } from "./firebase-ai";
import type { SalesSummary } from "../sell/utils/sales-analytics";
import { formatBRL } from "../sell/utils/sales-analytics";

function summaryToPromptPayload(summary: SalesSummary) {
  return {
    periodo: summary.periodLabelHuman,
    diasNoIntervalo: summary.dayCount,
    receitaTotal: summary.totalRevenue,
    receitaFormatada: formatBRL(summary.totalRevenue),
    quantidadeVendas: summary.saleCount,
    ticketMedio: formatBRL(summary.avgTicket),
    porPagamento: summary.byPayment.map((p) => ({
      forma: p.label,
      vendas: p.count,
      receita: formatBRL(p.revenue),
    })),
    topProdutos: summary.topProducts.slice(0, 5).map((p) => ({
      nome: p.name,
      quantidade: p.quantity,
      receita: formatBRL(p.revenue),
    })),
    amostraDiaria: summary.daily.slice(-7).map((d) => ({
      dia: d.label,
      receita: formatBRL(d.revenue),
      vendas: d.count,
    })),
  };
}

/**
 * Gera texto de insights em PT-BR com base nos agregados (Gemini no cliente).
 */
export async function generateSalesInsights(summary: SalesSummary): Promise<string> {
  const model = getSymplouGenerativeModel();
  const payload = summaryToPromptPayload(summary);
  const prompt = `Você é um analista de vendas para pequeno varejo no Brasil.

Dados agregados (JSON):
${JSON.stringify(payload, null, 2)}

Instruções:
- Responda APENAS em português do Brasil.
- Use markdown simples: títulos ## e ###, listas com -, negrito com **.
- Estruture em: visão geral (2–3 frases), oportunidades (bullet points), riscos ou atenção (se houver), 3 ações práticas para os próximos dias.
- Não invente números que não estejam nos dados; pode interpretar tendências dos últimos dias da amostra.
- Tom profissional e direto; sem floreio vazio.
- Limite aproximado: 320 palavras.`;

  const result = await model.generateContent(prompt);
  const text = result.response.text();
  if (!text?.trim()) {
    throw new Error("Resposta vazia do modelo.");
  }
  return text.trim();
}

/** Texto curto quando não há vendas no período */
export function emptyPeriodInsight(periodLabelHuman: string) {
  return `Não há vendas concluídas registradas neste período (${periodLabelHuman}). Quando houver movimento, os insights aparecerão aqui.`;
}
